<template>
  <i
    :class="iconClass"
    :style="iconStyle"
  >
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.88 5.05c3.18.4 5.67 2.89 6.07 6.07.06.51.49.88.99.88.04 0 .08 0 .12-.01.55-.07.94-.57.87-1.12a8.981 8.981 0 0 0-7.81-7.81c-.55-.06-1.05.33-1.11.88-.07.55.32 1.05.87 1.11Zm.38 2.11a1 1 0 0 0-1.22.72c-.14.54.18 1.08.72 1.22a3 3 0 0 1 2.15 2.15 1.003 1.003 0 0 0 1.22.72c.53-.14.85-.69.72-1.22a5.018 5.018 0 0 0-3.59-3.59Zm5.97 8.1-2.54-.29a1.99 1.99 0 0 0-1.64.57l-1.84 1.84a15.045 15.045 0 0 1-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52a2.001 2.001 0 0 0-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98Z"/></svg>
    <!-- eslint-enable -->
  </i>
</template>

<script>
import BaseIcon from '../BaseIcon.vue';

export default {
  name: 'DpIconPhoneCall',
  extends: BaseIcon,
  iconName: 'phone-call',
  iconCategory: 'action',
};
</script>
